import React from "react";
import VideoRenderer from "../video/VideoRenderer";
import PdfViewer from "../pdfviewer/PdfViewer";
import styles from "./ContentBox.module.css";

const ContentBox = ({ selectedAssignment, selectedTab }) => {
  const renderContent = () => {
    if (!selectedAssignment) {
      return (
        <div className={styles.emptyState}>
          Select an assignment to view content
        </div>
      );
    }

    switch (selectedTab) {
      case "Video": {
        const videoUrl = selectedAssignment.videoLink;
        return videoUrl ? (
          <VideoRenderer url={videoUrl} />
        ) : (
          <div className={styles.error}>No video available</div>
        );
      }

      case "Description": {
        const description = selectedAssignment.description;
        return (
          <div className={styles.descriptionContainer} style={{ marginTop: '5px' }}>
            {description ? (
              <div className={styles.descriptionContent}>
                {description.split("\n").map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
              </div>
            ) : (
              <div className={styles.emptyState}>No description available</div>
            )}
          </div>
        );
      }
      case "Materials": {
        const fileUrl = selectedAssignment.file || selectedAssignment.fileURL;
        return fileUrl ? (
          <PdfViewer documentPath={fileUrl} />
        ) : (
          <div className={styles.emptyState}>No materials available</div>
        );
      }

      case "Program": {
        const program = selectedAssignment.file;
        return (
          <div className={styles.programContainer}>
            {program ? (
              <div className={styles.programContent}>
                <a href={program} download className={styles.downloadLink}>
                  {program}
                  <i
                    className="bi bi-download"
                    style={{ marginLeft: "8px" }}
                  ></i>
                </a>
              </div>
            ) : (
              <div className={styles.emptyState}>
                No program content available
              </div>
            )}
          </div>
        );
      }

      default:
        return <div className={styles.emptyState}>Invalid tab selected</div>;
    }
  };

  return <div className={styles.contentBox}>{renderContent()}</div>;
};

export default ContentBox;